import { Error } from '../interface/upplm.common.interface';

export class GetPickupScheduleDetailsRequest {
    address: Address = new Address();
    clientKey?: string;
    preferredOptions?: PreferredOptions = new PreferredOptions();
    TransactionId: string;
}

export class PreferredOptions {
    pickupPlanTypeSelected?: PickupPlanTypeSelected = new PickupPlanTypeSelected();
    availableDaysAndServicesSelected?: Array<AvailableDaysAndServicesSelected> = [];
}

export class PickupPlanTypeSelected {
    pickupPlanType: string
}

export class AvailableDaysAndServicesSelected {
    dayOfWeekCode?: string;
    timeZone?: string;
    selectedPreferredTime?: string;
    selectedLatestTime?: string;
}

export class PickupScheduleDetailResponse {
    pickupPlanTypes: PickupTypePlan[];
    availableDaysAndServices: AvailableDayAndService[];
    errors: Error[];
    showPageEdit: boolean;
}

export class PickupTypePlan {
    pickupPlanType: string;
    validType?: boolean;
}

export class AvailableDayAndService {
    dayOfWeekCode: string;
    //date: string;
    preferredTime: TimePreference;
    latestTime: TimePreference;
    timeZone: string;
    selectedPreferredTime: string;
    selectedLatestTime: string;
    validTime: boolean;
}

export class TimePreference {
    startTime: string;
    endTime: string;
}


export class userDaysAndService {
    pickupPlanType: PickupTypePlan;
    selectedDaysAndService: AvailableDayAndService[];
}

export class ScheduleListDDL {
    unformattedTime: string;
    formattedTime: string;
    isdisabled: boolean;
}

export class ScheduleDetailToSave {
    pickupType: string;
    day: string;
    preferredTime: TimePreference;
    latestTime: TimePreference;
}

export class GenericSchedule {
    day: string = '';
    dayOfWeekCode: string = '';
    shortDay: string = '';
    selectedDay: boolean = false;
    preferredTime: ScheduleListDDL[];
    latestTime: ScheduleListDDL[];
    preferredSelected: string;
    latestSelected: string;
    isDisabled: boolean = false;
    error: ErrorSchedule = new ErrorSchedule()
}
export class ErrorSchedule {
    id?: string;
    code?: string;
    message?: string;
    position?: number;
}

export class Address {
    AddressLine1: string;
    AddressLine2: string;
    CityTown: string;
    StateProvince: string;
    CountryCode: string;
    PostalCode: string;
}

export interface PickupType {
    id: string;
    description: string;
}

export class GetPickupPlanRequest {
    clientKey: string;
}

export class GetPickupPlanResponse {
    clientKey: string;
    dailyEnabled: string;
    daySpecificEnabled: string;
    smartEnabled: string;
    availablePickupPlans: string[];
}